import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

import './transparent-header-layout.scss';
import { motion, AnimatePresence } from 'motion/react';

import Header from './components/header';
import Footer from './components/footer';
import FloatingButtons from '@/components/button/floating-buttons';

const TransparentHeaderLayout = () => {
	const pathname = useLocation().pathname;
	const [isOutletLoaded, setIsOutletLoaded] = useState(false);

	useEffect(() => {
		setIsOutletLoaded(true);
	}, []);

	useEffect(() => {
		// 스크롤 복원 로직
		const handleScrollToTop = () => {
			window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
		};

		requestAnimationFrame(() => {
			requestAnimationFrame(handleScrollToTop);
		});
	}, [pathname]);

	return (
		<div className="app-root-transparent">
			<Header isLandingPage={true} />

			<div className="contents-wrapper">
				<motion.div
					key={pathname}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 1 }}
				>
					<Outlet />
					<FloatingButtons />
					<AnimatePresence>
						{isOutletLoaded && (
							<motion.div
								initial={{ opacity: 0, y: 20 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{ duration: 0.5, delay: 0.5 }}
							>
								<Footer />
							</motion.div>
						)}
					</AnimatePresence>
				</motion.div>
			</div>
		</div>
	);
};

export default TransparentHeaderLayout;
